import { render } from "./news.vue?vue&type=template&id=236c246e&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=236c246e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-236c246e"

export default script